import { getComponentKey } from 'utils/getComponentKey'
import { suffix } from './suffix'
import { constants } from 'consts'

import 'polyfills/startsWith'

export const processResponse = (response) => {
  if (Array.isArray(response)) { return response }
  return { ...response, isDirty: false }
}
export const lookupReducer = (state, action, prefix, convert = {}) => {
  if (action.type.startsWith(`${prefix}/`)) {

    switch(action.type) {
      case `${prefix}/${suffix.entity}${suffix.fetching}`: return { ...state, fetching: true }
      case `${prefix}/${suffix.entity}${suffix.fetched}`: return { ...state, fetching: false, error: null, entity: processResponse(convert.transformPayload ? convert.transformPayload(action.payload) : action.payload) }
      case `${prefix}/${suffix.entity}${suffix.rejected}`: return { ...state, fetching: false, error: action.payload }
      
      default: return state
    }
  }
  return state
}

export const reducer = (state, action, prefix, convert = {}) => {
  if (action.type.startsWith(`${prefix}/`) || action.type === constants.REFRESH_NEEDED_ACTION) {

    switch(action.type) {
      case `${prefix}/${suffix.entity}${suffix.fetching}`: return { ...state, fetching: true }
      case `${prefix}/${suffix.entity}${suffix.fetched}`: return { ...state, fetching: false, error: null, entity: processResponse(convert.transformPayload ? convert.transformPayload(action.payload) : action.payload) }
      case `${prefix}/${suffix.entity}${suffix.rejected}`: return { ...state, fetching: false, error: action.payload }

      case `${prefix}/${suffix.update}`: return { 
        ...state, 
        entity: { 
          ...state.entity, 
          ...(convert.transformBack ? convert.transformBack(action.payload.delta) : action.payload.delta), 
          isDirty: (action.payload.options || {}).ignoreDirtyFlag ? state.entity.isDirty : true }}
      case `${prefix}/${suffix.saving}`: return { ...state, saving: true }
      case `${prefix}/${suffix.saved}`: return { ...state, saving: false, gridKey: getComponentKey(), entity: { ...state.entity, ...(convert.transformPayload ? convert.transformPayload(action.payload) : action.payload), isDirty: false } }
      case `${prefix}/${suffix.deleting}`: return { ...state, deleting: true }
      case `${prefix}/${suffix.deleted}`: return { ...state, deleting: false, gridKey: getComponentKey() }
      case `${prefix}/${suffix.restoring}`: return { ...state, restoring: true }
      case `${prefix}/${suffix.restored}`: return { ...state, restoring: false, gridKey: getComponentKey() }
      case `${prefix}/${suffix.refresh}`: return { ...state, gridKey: getComponentKey() }
      case `${prefix}/${suffix.error}`: return { ...state, ...action.payload }
      
      case constants.REFRESH_NEEDED_ACTION: return action.payload === prefix ? { ...state, gridKey: getComponentKey() } : state
      default: return state
    }
  }
  return state
}